<template >
    <el-dialog
      title="教练员注册复核申请"
      :visible.sync="visibleAdd"
      class="detail-info-dia"
      width="750px"
    >
        <div v-loading="loading">
        
        
        <div class="fo-item">
            <span class="label">提交人：</span>
            <span class="text">{{reconsider.name}}</span>
        </div>
        <div class="fo-item">
            <span class="label">提交时间：</span>
            <span class="text">{{reconsider.create_time | time(true)}}</span>
        </div>
        <div class="fo-item">
            <span class="label">复核申请理由：</span>
            <span class="text">{{reconsider.reconsider_reason || '--'}}</span>
        </div>
        <div class="fo-item">
            <span class="label">复核申请附件：</span>
            <span class="text fileList" v-if="reconsider.reconsider_file_address"><a :href="reconsider.reconsider_file_address" target="_blank">{{reconsider.reconsider_file_name}}</a></span>
            <span class="text" v-else> -- </span>
        </div>
        <div class="fo-item">
            <span class="label">复核申请状态：</span>
            <span class="text">{{reconsider.reconsider_status | getStatus}}</span>
        </div>
        <div class="fo-item" v-if="reconsider.audit_msg">
            <span class="label">审核理由：</span>
            <span class="text">{{reconsider.audit_msg}}</span>
        </div>
        <template v-if="reconsider.reconsider_status === 'audit' && ['CoachSubmit','EnterOrgAudit','LeaveOrgAudit'].includes(reconsider.transfer_item_status) && ['super','system'].includes(userType)">
            <div style="margin:20px 0;border-top:1px solid black"></div>
            <div class="auditInput">
                <el-form ref="checkForm" :model="formData" :rules="formRules" label-width="0px">
                    <el-form-item label="" prop="opinion"  style="margin-bottom: 10px" :rules="{
                    required: true,
                    message: `请填写审核理由`,
                    trigger: `blur`,
                  }">
                
                        <el-input type="textarea"  :rows="2" v-model.trim="formData.opinion" :maxlength="limit" placeholder="请输入审核理由" ></el-input>
            
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn-box">
                <el-popover
                  ref="popover1"
                  placement="top"
                  visible-arrow="false"
                  v-model="isShowPop"
                  width="400"
                >
                    <p class="pop-msg">{{ popMsg }}</p>
                    <div class="pop-btn-list" style="display:flex;justify-content:center">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="handleConfirmPop(true)"
                        >确认</el-button
                        >
                        <el-button
                          type="danger"
                          size="mini"
                          @click="handleConfirmPop(false)"
                          style="background-color:#f00;color:#fff"
                        >取消</el-button
                        >
                    </div>
                    <div class="e" slot="reference"></div>
                    <div class="btn save mr50 ml100" style="width: 90px" slot="reference" @click="handleDialogAction('pass')">通过</div>
                    <div
                      class="btn cancel"
                      slot="reference"
                      @click="handleDialogAction('refused')"
                    >
                        拒绝
                    </div>
                </el-popover>
            </div>
        </template>
        </div>
    </el-dialog>
</template>

<script>
  import { coach_transfer_fuyi_info,coach_transfer_fuyi_audit } from "@/api/system_manager/api";
  import { storageData } from "@/assets/js/storage";
    export default {
        name: "ReconsiderSeeDetails",
        props: {
            dialogData: {
                type: Object,
            },
            isShowAddDialog: {
                type: Boolean,
                default: false
            },

        },
        computed: {
            visibleAdd: {
                get() {
                    return this.isShowAddDialog;
                },
                set(val) {
                    this.$emit('update:isShowAddDialog', val)
                }
            }
        },
        created() {
          this.getReconsiderInfo();
        
        },
      filters: {
        getStatus(status) {
          let str = '';
          switch (status) {
            case "audit" : str="审核中";break;
            case "pass" : str="审核通过";break;
            case "refused" : str="审核拒绝";break;
          }
          return str;
        },
      },
      methods: {
        getReconsiderInfo() {
          const postData = {
            reconsider_uuid:this.dialogData.reconsider_uuid
          };
          coach_transfer_fuyi_info(postData)
          .then(({ data }) => {
            if (data.status !== 0) {
              this.$message.error(data.msg);
              return;
            }
            this.reconsider = data.result.reconsider;
            this.loading = false;
          })
          .catch((err) => {
            console.error("err", err);
          });
        },
        
        // status: 1（通过） 2（拒绝）
        handleDialogAction(status) {
          this.$refs["checkForm"].validate((valid) => {
            if (valid) {
              if (this.opinionError) this.opinionError = "";
              if (!this.formData.opinion) {
                this.opinionError = "请填写审核理由";
                this.isShowPop = false;
              } else {
                this.isShowPop = true;
              }
              this.popMsg = status === 'pass' ? "通过复核申请后，需要会员协会重新审核，确认该操作吗？" : "教练员只有一次复核申请机会，拒绝复核申请后，学员则变更失败，确认该操作吗？";
              this.actionStatus = status;
            } else {
              this.$message.error("请填写审核理由");
            }
          });
          
        },
        handleConfirmPop(status) {
          if (status) {
            this.reconsiderAudit();
          }
          this.isShowPop = false;
        },
        reconsiderAudit() {
          const postData = {
            reconsider_uuid:this.reconsider.reconsider_uuid,
            reconsider_status:this.actionStatus,
            audit_msg:this.formData.opinion,
          };
          coach_transfer_fuyi_audit(postData)
          .then(({ data }) => {
            if (data.status !== 0) {
              this.$message.error(data.msg);
              return;
            }
            this.$message.success("复核申请审核成功");
            this.getReconsiderInfo();
            this.$emit("auditVerify", this.actionStatus);
          })
          .catch((err) => {
            console.error("err", err);
          });
        },
      },
      
        data() {
            return {
              userType:storageData.getUserType(),
              formData: {
                opinion: "",
              },
  
              formRules: {
                opinion: [],
              },
              reconsider:{},
              opinionError: "",
              limit: 200,
              isShowPop: false,
              actionStatus: 1, // 1（通过） 2（拒绝）
              popMsg: "",
              loading:true,
            }
        }
    }
</script>

<style lang="stylus" scoped>
    $margin = 5px
    .detail-info-dia{
        .fo-item{
            display:flex;
            padding-right:$margin;
            padding-left:$margin;
            margin-bottom:6px;
            font-size:16px;
            .label{
                width:130px;
                text-align:right;
            }
            .text{
                word-wrap:break-word;
                width:600px;
            }
            .fileList{
                color:#4CD964
                display:block
            }
        }
        .btn-box{
            display: flex;
            justify-content:center
        }
        .save{
            width 80px
            padding 10px
            display inline-block
            height 100%
            background-color #4CD964
            text-align center
            color #FFFFFF
            cursor pointer
        }
    
        .cancel{
            width 78px
            display inline-block
            // height 50px
            background-color #FF0000
            text-align center
            color #FFFFFF
            padding 9px
            margin-left 20px
            cursor pointer
        }
    }
</style>
